import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Search, UserPlus, UserMinus } from "lucide-react";
import BadgesShelf from "../components/BadgesShelf";

export default function People() {
  const { user: me } = useAuth();
  const [q, setQ] = useState("");
  const [users, setUsers] = useState([]);
  const [friendIds, setFriendIds] = useState([]);

  const load = async () => {
    const { data } = await api.get("/users", { params: q ? { q } : {} });
    setUsers(data.filter((u) => u.id !== me?.id));
    const { data: f } = await api.get("/friends");
    setFriendIds(f.map((x) => x.id));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  const toggle = async (id) => {
    if (friendIds.includes(id)) {
      await api.delete(`/friends/${id}`); setFriendIds(friendIds.filter((x) => x !== id));
      toast("Unfollowed");
    } else {
      await api.post(`/friends/${id}`); setFriendIds([...friendIds, id]);
      toast.success("Added to your hive");
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[color:var(--bee-muted)] mb-2">Your hive</p>
        <h1 className="font-display text-4xl font-bold tracking-tight">People</h1>
        <p className="text-[color:var(--bee-muted)] mt-2">Discover other students, follow their profiles, build your study circle.</p>
      </div>

      <div className="relative mb-6">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--bee-muted)]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or school..." data-testid="people-search" className="bee-input w-full pl-9" />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {users.length === 0 && <div className="text-[color:var(--bee-muted)] col-span-2 text-center py-10">No students yet — invite a classmate to join FocusBee.</div>}
        {users.map((u) => (
          <div key={u.id} className="bee-card p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-testid={`person-${u.id}`}>
            <div className="flex items-center gap-4 w-full sm:w-auto sm:flex-1 min-w-0">
              <Link to={`/u/${u.id}`}>
                <div className="w-14 h-14 hex-clip flex items-center justify-center font-display text-xl font-bold text-white flex-shrink-0" style={{ background: u.avatar_color }}>
                  {u.name.charAt(0).toUpperCase()}
                </div>
              </Link>
              <div className="flex-1 min-w-0">
                <Link to={`/u/${u.id}`} className="font-semibold hover:text-[color:var(--bee-primary-hover)] block truncate">{u.name}</Link>
                <div className="text-xs text-[color:var(--bee-muted)] truncate">{u.school || "Student"} · {u.subjects.length} subjects</div>
                {u.bio && <p className="text-xs text-[color:var(--bee-muted)] mt-1 line-clamp-2">{u.bio}</p>}
                <div className="mt-2"><BadgesShelf earned={u.earned_badges || []} compact /></div>
              </div>
            </div>
            <button
              onClick={() => toggle(u.id)}
              data-testid={`follow-${u.id}`}
              className={`w-full sm:w-auto ${friendIds.includes(u.id) ? "bee-btn-secondary" : "bee-btn-primary"} text-xs flex items-center justify-center gap-1`}
            >
              {friendIds.includes(u.id) ? <><UserMinus size={12} /> Following</> : <><UserPlus size={12} /> Add</>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
